<template lang="pug">
  div.geo.apos
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :hideImportBtn="true"
      :showViewPanel="false"
      :hasTariffYearSelect="true"
      @changeTariffYearSelect='changeTariffYearSelect'
      :showExport="true"
      :endpointExport="endpointExport()"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      :actionColumnWidth="100"
      :customColumnWidth="customColumnWidth"
    )

    router-view
</template>

<script>
import { export_document, map } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'

export default {
  mixins: [tableMixin],
  data: () => ({
    customColumnWidth: {
      is_active: '100px',
    },
  }),
  methods: {
    getEndpoint(route) {
      return map.apos(route)
    },
    getDeleteUrl(id) {
      return map.apoDelete(id)
    },
    changeTariffYearSelect(year) {
      this.getItemsWithTariffYear(year)
    },
    endpointExport() {
      return export_document.apo(this.$route)
    },
    async getItemsWithTariffYear(year) {
      const route = this.$route
      route.query.tariff_year = year
      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: map.apos(route),
      })

      this.$store.commit('mutateEndpoint', {
        endpoint: map.apos(route),
        response,
      })
    },
  },
}
</script>
